<template>
    <Head title="پنل کاربری"/>
    <dashboard>
        <template v-slot:breadcrumb>
            <breadcrumb :links="[{title: 'پنل کاربری'}]"/>
        </template>
        <div v-if="discountCodes.length" class="position-relative">
            <div class="discounts-splide">
                <div class="pb-5 pt-3 splide__track">
                    <ul class="splide__list">
                        <li v-for="discountCode in discountCodes" class="splide__slide">
                            <div class="shadow p-4 rounded">
                                <h5 class="fw-bold">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M3.35288 15.0496L4.08306 14.8783L3.35288 15.0496ZM3.35288 8.95043L2.6227 8.77915L3.35288 8.95043ZM20.6471 8.95044L21.3773 8.77916L20.6471 8.95044ZM20.6471 15.0496L21.3773 15.2208L20.6471 15.0496ZM15.0496 20.6471L15.2208 21.3773L15.0496 20.6471ZM8.95044 20.6471L9.12171 19.9169L8.95044 20.6471ZM8.95043 3.35288L8.77916 2.6227L8.95043 3.35288ZM15.0496 3.35288L15.2208 2.6227L15.0496 3.35288ZM4.08306 14.8783C3.63898 12.9851 3.63898 11.0149 4.08306 9.12171L2.6227 8.77915C2.12577 10.8976 2.12577 13.1024 2.6227 15.2209L4.08306 14.8783ZM19.9169 9.12171C20.361 11.0149 20.361 12.9851 19.9169 14.8783L21.3773 15.2208C21.8742 13.1024 21.8742 10.8976 21.3773 8.77916L19.9169 9.12171ZM14.8783 19.9169C12.9851 20.361 11.0149 20.361 9.12171 19.9169L8.77916 21.3773C10.8976 21.8742 13.1024 21.8742 15.2208 21.3773L14.8783 19.9169ZM9.12171 4.08306C11.0149 3.63898 12.9851 3.63898 14.8783 4.08306L15.2208 2.6227C13.1024 2.12577 10.8976 2.12577 8.77916 2.6227L9.12171 4.08306ZM9.12171 19.9169C6.62161 19.3305 4.6695 17.3784 4.08306 14.8783L2.6227 15.2209C3.33924 18.2756 5.72442 20.6608 8.77916 21.3773L9.12171 19.9169ZM15.2208 21.3773C18.2756 20.6608 20.6608 18.2756 21.3773 15.2208L19.9169 14.8783C19.3305 17.3784 17.3784 19.3305 14.8783 19.9169L15.2208 21.3773ZM14.8783 4.08306C17.3784 4.6695 19.3305 6.62161 19.9169 9.12171L21.3773 8.77916C20.6608 5.72441 18.2756 3.33924 15.2208 2.6227L14.8783 4.08306ZM8.77916 2.6227C5.72441 3.33924 3.33924 5.72441 2.6227 8.77915L4.08306 9.12171C4.6695 6.6216 6.62161 4.6695 9.12171 4.08306L8.77916 2.6227Z"
                                            fill="#212529"/>
                                        <path
                                            d="M13.0739 8.50204L13.6042 9.03237L13.0739 8.50204ZM10.4627 11.1133L10.993 11.6436H10.993L10.4627 11.1133ZM15.498 10.9261L14.9676 10.3958L14.9676 10.3958L15.498 10.9261ZM12.8867 13.5373L12.3564 13.007L12.8867 13.5373ZM8.77168 15.8672L8.95358 16.5948H8.95358L8.77168 15.8672ZM8.26699 15.9934L8.44889 16.721H8.44889L8.26699 15.9934ZM8.00661 15.733L8.73421 15.9149L8.73421 15.9149L8.00661 15.733ZM8.13278 15.2283L7.40517 15.0464L7.40517 15.0464L8.13278 15.2283ZM12.5436 7.97171L9.93236 10.5829L10.993 11.6436L13.6042 9.03237L12.5436 7.97171ZM14.9676 10.3958L12.3564 13.007L13.4171 14.0676L16.0283 11.4564L14.9676 10.3958ZM8.58978 15.1396L8.08509 15.2658L8.44889 16.721L8.95358 16.5948L8.58978 15.1396ZM8.73421 15.9149L8.86039 15.4102L7.40517 15.0464L7.279 15.5511L8.73421 15.9149ZM8.08509 15.2658C8.47712 15.1678 8.83222 15.5229 8.73421 15.9149L7.279 15.5511C7.10236 16.2576 7.74235 16.8976 8.44889 16.721L8.08509 15.2658ZM12.3564 13.007C11.3173 14.0461 10.0154 14.7832 8.58978 15.1396L8.95358 16.5948C10.6429 16.1725 12.1858 15.299 13.4171 14.0676L12.3564 13.007ZM9.93236 10.5829C8.70104 11.8142 7.82751 13.3571 7.40517 15.0464L8.86039 15.4102C9.21679 13.9846 9.95394 12.6827 10.993 11.6436L9.93236 10.5829ZM14.2859 7.25C13.6324 7.25 13.0057 7.50961 12.5436 7.97171L13.6042 9.03237C13.785 8.85157 14.0302 8.75 14.2859 8.75V7.25ZM15.25 9.71407C15.25 9.96975 15.1484 10.215 14.9676 10.3958L16.0283 11.4564C16.4904 10.9943 16.75 10.3676 16.75 9.71407H15.25ZM16.75 9.71407C16.75 8.3532 15.6468 7.25 14.2859 7.25V8.75C14.8184 8.75 15.25 9.18163 15.25 9.71407H16.75ZM14.7628 10.7125C14.5412 10.7864 14.1195 10.6949 13.7123 10.2877C13.3051 9.88055 13.2136 9.45878 13.2875 9.23717L11.8644 8.76283C11.5343 9.75325 12.0488 10.7455 12.6516 11.3484C13.2545 11.9512 14.2467 12.4657 15.2372 12.1356L14.7628 10.7125Z"
                                            fill="#212529"/>
                                    </svg>
                                    کد تخفیف: {{ discountCode.code }}
                                </h5>
                                <div class="text-dark" v-html="discountCode.description">
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="mb-4 hstack justify-content-between gap-2">
            <h2 class="fw-bolder mb-0">
                محصولات
                <span class="text-gradient-primary">پرفروش</span>
            </h2>
            <a href="/shop" class="link-dark">مشاهده همه

                <svg class="ms-2" width="23" height="23" viewBox="0 0 23 23" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_612_387)">
                        <path
                            d="M8.55589 2.75758L9.23048 3.43217L1.9294 10.7333L22.0505 10.7366L21.9105 11.7877L1.88695 11.7896L9.2613 19.164L8.55589 19.8694L0 11.3135L8.55589 2.75758Z"
                            fill="currentColor"/>
                    </g>
                    <defs>
                        <clipPath id="clip0_612_387">
                            <rect width="16" height="16" fill="white"
                                  transform="translate(0 11.3135) rotate(-45)"/>
                        </clipPath>
                    </defs>
                </svg>

            </a>
        </div>

        <div class="row g-4">
            <div v-for="product in bestSellerProducts" class="col-sm-6 col-lg-4">
                <product-content :product="product"/>
            </div>
        </div>

    </dashboard>
</template>

<script>
import Dashboard from "../../Layouts/Dashboard";
import ProductContent from "../../Components/ProductContent";
import Breadcrumb from "../../Components/Breadcrumb";
import {Head} from '@inertiajs/inertia-vue3';
import Splide from "@splidejs/splide";

export default {
    components: {
        Dashboard,
        ProductContent,
        Breadcrumb,
        Head,
    },
    props: {
        bestSellerProducts: Array,
        discountCodes: Array,
    },
    mounted() {
        if (this.discountCodes.length) {
            new Splide('.discounts-splide', {
                direction: 'rtl',
                perPage: 2,
                gap: 16,
                arrows: false,
                autoplay: true,
                breakpoints: {
                    640: {
                        perPage: 1,
                    }
                }
            }).mount();
        }
    }
}
</script>

<style scoped>

</style>
